import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';
export default (function (params) {
  const { isRequestSuccessed, exec, rst } = useRequest({
    url: '',
    name: 'IPQC_PROCESS_INSPECTION_DELETE',
    method: 'DELETE',
  });
  useEffect(() => {
    if (params) {
      exec('/api/ipqc/inspection/main/' + params.id + '?production_order_oid=' + params.production_order_oid + '&id=' + params.id)
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);
  return [isRequestSuccessed, rst];
})
